import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import BrandIntroSection from './components/BrandIntroSection';
import PhilosophySection from './components/PhilosophySection';
import TeacherSection from './components/TeacherSection';
import AudienceSection from './components/AudienceSection';
import TeachingFeaturesSection from './components/TeachingFeaturesSection';
import LearningPathSection from './components/LearningPathSection';
import InstrumentSection from './components/InstrumentSection';
import NotesPreviewSection from './components/NotesPreviewSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#faf8f5]">
      <Navbar />
      <HeroSection />
      <BrandIntroSection />
      <AudienceSection />
      <PhilosophySection />
      <TeacherSection />
      <TeachingFeaturesSection />
      <LearningPathSection />
      <NotesPreviewSection />
      <InstrumentSection />
      <FaqSection />
      <CtaSection />
      <Footer />
    </div>
  );
}